import { getPortalBaseUrl } from '../config/getPortalBaseUrl'
import { getNavigationUrls } from '../config/navigation'

import { getAppBaseUrl } from './getAppBaseUrl'

function normalizeOrigin(url: string): string | null {
  try {
    return new URL(url).origin
  } catch {
    return null
  }
}

/** Server components and route handlers. */
export function isPortalAppOnServer(): boolean {
  const appBase = getAppBaseUrl()
  const portalBase = getPortalBaseUrl()

  if (!appBase || !portalBase) {
    return false
  }

  const appOrigin = normalizeOrigin(appBase)
  const portalOrigin = normalizeOrigin(portalBase)

  if (appOrigin && portalOrigin) {
    return appOrigin === portalOrigin
  }

  return appBase === portalBase
}

/** Client hooks and components. */
export function isPortalAppOnClient(): boolean {
  if (typeof window === 'undefined') {
    return isPortalAppOnServer()
  }

  const portalOrigin = normalizeOrigin(getNavigationUrls().portal)
  if (!portalOrigin) {
    return false
  }

  return window.location.origin === portalOrigin
}
